<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-满送活动-添加
    -->
    <el-dialog
    title="添加满送活动"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="活动名称" :label-width="formLabelWidth" prop="active_name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.active_name" placeholder="请输入活动名称"></el-input>
      </el-form-item>
      <el-form-item label="满类型" :label-width="formLabelWidth">
        <div>
          <el-radio v-model="form.full_type" :label="1">满金额</el-radio>
          <el-radio v-model="form.full_type" :label="2">满件数</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="满值" :label-width="formLabelWidth" prop="full_value" :rules="[{required: true,message: ' '}]">
        <el-input type="number" :precision="1" :step="1" :min="0" placeholder="请输入满值" v-model="form.full_value"></el-input>
      </el-form-item>



      <div class="common-form">赠送产品</div>   
   
      <el-form-item >
        <el-button icon="el-icon-plus" @click="changeProduct(form.products)">选择商品</el-button>
        <el-table size="small" :data="form.products"   border style="width: 100%" v-loading="loading">
          <el-table-column prop="product_name" label="商品"></el-table-column>
          <el-table-column prop="spec_value" label="规格"></el-table-column>
          <el-table-column prop="unit" label="计量单位"></el-table-column>
          <el-table-column prop="set_num" label="赠送数量">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.set_num"
                placeholder="请输入数量"
                type="number"
              ></el-input>

            </template>

          </el-table-column>
          <el-table-column prop="product_price" label="单价">
            <template slot-scope="scope">
            
           {{ scope.row.product_price }}
            </template>

          </el-table-column>
          

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="del(scope.$index)" size="mini">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        </el-form-item>

     
        <div>秒杀活动产生的订单不参与赠送商品</div>


    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--商品图片组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
    <Product :isproduct="isproduct" :excludeIds="excludeIds" :islist="islist" @closeDialog="closeDialogFunc"></Product>

 
  </div>
</el-dialog>
  
</template>

<script>
import FulldeliveryApi from '@/api/fulldelivery.js';

import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import Supply from '@/components/supply/supply_common.vue';
import Product from '@/components/product/SkuProduct';
import {mergeTable} from '@/utils/table.js'
export default {
  components: {
    Product,
     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter,
     Supply,
  },
  data() {
    return {
              /*左边长度*/
              formLabelWidth: '120px',
         /*是否上传图片*/
         isupload: false,
      isImg: false,  
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        active_name:"",
        full_type:1,
        full_value:"",
        product_sku_ids:[],
        products:[],
        supply:{},
      },
      loading: false,
      /*验证规则*/
      rules: {
        active_name: [{ required: true, message: '请输入满送活动名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,

      isProductUpload:false,
      code:"album",

      isproduct: false,
      /*产品去重*/
      excludeIds: [],
      islist:true,

    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
    del(ind){
      this.form.products.splice(ind,1);
 
    },
    /*关闭弹窗*/
    closeDialogFunc(e) {
    
      let self = this;
      self.isproduct = false;
      if (e.type === 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          let obj = {
            product_name: item.product_name,
            product_id: item.product_id,
            product_sku_id: item.product_sku_id,
            product_price: item.product_price,
            product_image: item.product_image,
            unit: item.unit,
            spec_value:item.spec_value,
            status:0,//0 未入库 1  已入库
            set_num:1,
            file_path:item.image.file_path,
            rk:item.warehouse_management,
            category_name:item.category_name,
          };
          arr.push(obj)
        }
        self.form.products = self.form.products.concat(arr);
        self.form.products = mergeTable(this.form.products);

      
      }
    },
    /*打开添加*/
    changeProduct(list) {
      let arr = [];
      list.forEach(item => {
        arr.push(item.product_sku_id);
      });
      this.excludeIds = arr;
      this.isproduct = true;
    },

     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      var product_sku_ids =[];
      for(var i=0;i<self.form.products.length;i++){
          product_sku_ids.push(self.form.products[i].product_sku_id);
        }
        self.form.product_sku_ids = product_sku_ids
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          FulldeliveryApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/fulldelivery/index/part/add.vue